import * as React from "react";
import { CssVarsProvider, useColorScheme } from "@mui/joy/styles";
import Box from "@mui/joy/Box";
import CssBaseline from "@mui/joy/CssBaseline";
import IconButton from "@mui/joy/IconButton";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import framesxTheme from "../theme";
import TermsOfService from "../components/_sections/Landing/TermsOfService";
import Typography from "@mui/joy/Typography";
import { Link as RouterLink } from "react-router-dom";

function ColorSchemeToggle() {
  const { mode, setMode } = useColorScheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  if (!mounted) {
    return null;
  }
  return (
    <IconButton
      id="toggle-mode"
      size="lg"
      variant="soft"
      color="neutral"
      onClick={() => {
        if (mode === "light") {
          setMode("dark");
        } else {
          setMode("light");
        }
      }}
      sx={{
        position: "fixed",
        zIndex: 999,
        top: "1rem",
        right: "1rem",
        borderRadius: "50%",
        boxShadow: "",
      }}
    >
      {mode === "light" ? <DarkModeRoundedIcon /> : <LightModeRoundedIcon />}
    </IconButton>
  );
}

export default function TermsOfServicePage() {
  return (
    <CssVarsProvider disableTransitionOnChange theme={framesxTheme}>
      <CssBaseline />
      <ColorSchemeToggle />
      <Box
        sx={{
          position: "fixed",
          width: "100%",
          backgroundColor: "background.body",
          zIndex: 998,
          padding: "1.3% 1%",
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
          borderBottom: "2px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <IconButton
          size="md"
          component={RouterLink}
          to="/dashboard"
        >
          <img src={process.env.REACT_APP_LOGO} alt="Icon" height="33px" width="33px"/>
        </IconButton>
        <Typography 
        level="h3" 
        component={RouterLink}
        to="/dashboard"
        sx={{ marginLeft: "1%", alignSelf: "center" }}>
          {process.env.REACT_APP_NAME}
        </Typography>
      </Box>
      <Box sx={{ height: "80px" }} />
      <Box
        sx={{
          height: "calc(100vh - 80px)", // Adjust this value based on the height of your spacer
          overflowY: "scroll",
          scrollSnapType: "y mandatory",
          "& > div": {
            scrollSnapAlign: "start",
          },
        }}
      >
        <TermsOfService />
      </Box>

    </CssVarsProvider>
  );
}
